import * as React from "react";
import { SVGProps } from "react";

const Aelf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    viewBox="0 0 201 197"
    {...props}
  >
    <style>{".st0{fill:#2b5eba}"}</style>
    <circle cx={158.9} cy={98.5} r={42.1} className="st0" />
    <circle cx={105.7} cy={20.3} r={20.3} className="st0" />
    <circle cx={105.7} cy={176.8} r={20.3} className="st0" />
    <path
      d="M96.4 128.9c1.2.4 2.5.6 3.8.6 7 0 12.7-5.7 12.7-12.7s-5.7-12.7-12.7-12.7c-4.5 0-8.4 2.3-10.7 5.8v.1c-.4.5-.7 1.1-.9 1.7-14 24.7-42.1 8.2-42.1 8.2-4.6-2.7-9.9-4.3-15.7-4.3-16.9 0-30.6 13.7-30.6 30.6s13.7 30.6 30.6 30.6c11.8 0 22.1-6.7 27.1-16.5v-.1c.9-1.7 1.6-3.5 2.2-5.4 14.6-33.5 36.3-25.9 36.3-25.9zM89.2 84c.6 1.1 1.4 2.2 2.3 3.1 5 5 13 5 17.9 0 5-5 5-13 0-17.9-3.2-3.2-7.6-4.3-11.6-3.4h-.1c-.6.1-1.3.3-1.9.6-27.4 7.6-35.6-24-35.6-24-1.3-5.2-4-10.1-8-14.1-12-12-31.3-12-43.2-.1S-3 59.5 9 71.4c8.4 8.4 20.3 10.9 30.9 7.5h.1c1.8-.6 3.6-1.4 5.4-2.3C79.3 63.2 89.2 84 89.2 84z"
      className="st0"
    />
  </svg>
);

export default Aelf;
